module.exports = __webpack_public_path__ + "img/d-p-02.d9d3a560.png";